/* eslint-disable */
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
/* import { getFirestore } from "https://www.gstatic.com/firebasejs/9.0.1/firebase-app.js";
 */
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA7sog1Q02SgDsTc_ztIQg9Av73JTVDOZE",

  authDomain: "niku-finance.firebaseapp.com",

  projectId: "niku-finance",

  storageBucket: "niku-finance.appspot.com",

  messagingSenderId: "1044218978623",

  appId: "1:1044218978623:web:7eb5ceb9be1f240019f38a",

  measurementId: "G-ZRME1ZZS7F",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig, "Finance");
export const dbFinance = app;
